export const AUSPOST_AGREE	= 'AUSPOST_AGREE'

export function agreeToAusPost(){
	return {
		type: AUSPOST_AGREE,
	}
}



// WEBPACK FOOTER //
// ./node_modules/mb-app-common/store/actions/australia-post.js